import type React from "react";

import { Suspense } from "react";

import { FiltersBar } from "./filters";
import { PageHeader } from "./header";
import { Pagination } from "./pagination";
import { Results } from "./results";

export const BooksPage: React.FC = () => {
  return (
    <div className="container mx-auto flex-grow px-4 py-8">
      <div className="flex flex-col gap-6">
        <PageHeader />
        <FiltersBar />
        <Suspense>
          <Results />
          <Pagination />
        </Suspense>
      </div>
    </div>
  );
};
